import { DataTable, Loader } from "@/components";
import useProperties from "./useProperties";
import { Button } from "@/components/ui";

const Properties = () => {
  const {
    globalFilter,
    setGlobalFilter,
    columns,
    isLoadingProperties,
    propertiesData,
    onCancel,
    onRowClick,
    isLoadingBom,
  } = useProperties();

  return (
    <div className="py-4 md:py-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <h2 className="text-lg font-[500] text-gray-700 items-start flex">
            Properties
          </h2>
        </div>
      </div>

      {/* Responsive Table */}
      {isLoadingProperties || isLoadingBom ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={(propertiesData?.data || [])?.sort(
              (a: any, b: any) =>
                new Date(b.updatedAt).getTime() -
                new Date(a.updatedAt).getTime()
            )}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
          />
          <div className="flex flex-row justify-end gap-3  py-3">
            <Button variant="outline" type="button" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default Properties;
